export const EMAIL_TYPE_OPTIONS = [
  { value: 'NO_REPLY', label: 'No Reply' },
  { value: 'NOTIFICATION', label: 'Notification' },
  { value: 'UPDATES', label: 'Updates' },
  { value: 'MARKETING', label: 'Marketing' },
  { value: 'RECEIPT', label: 'Receipt' },
]

export const getEmailTypeLabel = (emailType) =>
  EMAIL_TYPE_OPTIONS.find((option) => option.value === emailType)?.label ||
  emailType ||
  'No Reply'
